module.exports = __webpack_public_path__ + "media/images/gallery/constellations/bootes/boo_vis-4862524412830f019241c962555d8438.jpg";